import { S as Swiper } from './swiper-core-PnKJBlxA.js';
import { P as Pagination } from './pagination-DayBomWe.js';
import { A as A11y } from './a11y-Dw_0tDap.js';

class UspsSlider extends HTMLElement {
  constructor() {
    super();

    this.dataOptions = JSON.parse(this?.dataset?.options || '{}');
  }

  connectedCallback() {
    this.swiperInstance = new Swiper(this, {
      modules: [A11y, Pagination],
      loop: false,
      autoplay: false,
      direction: `horizontal`,
      slidesPerView: 1,
      spaceBetween: 16,
      centerInsufficientSlides: true,
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 24 },
        1024: { slidesPerView: 4, spaceBetween: 24 },
        1280: { slidesPerView: 5, spaceBetween: 24 },
      },
      ...this.dataOptions,
    });
  }
}

if (!customElements.get('usps-slider')) {
  customElements.define('usps-slider', UspsSlider);
}
